import React, { Component } from 'react';
import CSELogo from './assets/img/cse-logo.png';
import FullScreenPopup from './FullScreenPopup';
import data from './assets/data.json';
import pragmaworld from './assets/img/pragma.jpg';
import datalab from './assets/img/datalab.jpg';
import auntielucinda from './assets/img/auntielucinda.jpg';
import avakian from './assets/img/avakian.jpg';
import bodysculptor from './assets/img/bodysculptor.jpg';
import crawford from './assets/img/crawford.jpg';
import cseuoi from './assets/img/cseuoi.jpg';
import funtales4kids from './assets/img/funtales4kids.jpg';
import mbawinner from './assets/img/mbawinner.png';
import mo from './assets/img/mo.jpg';
import roundaroundtire from './assets/img/roundaroundtire.jpg';
import vervendo from './assets/img/vervendo.jpg'

class Projects extends React.Component {


	render() {
	return (
			<div className="projects-content">
				<div className="project-title">
						<h2>Projects</h2>
					</div>

				<div className="featured-project">
					<div className="featured-title">
						<span className="featured-text">Featured Project:</span> Schema History Investigator
					</div>
					<p>A web-based application that provides the user a variety of tools to explore the version 
					histories of database schemata.</p>
					<p>The application is built using the model-view-controller (MVC) architectural pattern. 
 						I used nodejs for the back-end to implement the business logic of the application
 						 along with express.js to create the RESTful API of the app. In the front-end I used Angular 4, 
 						 Bootstrap 3, HTML and CSS to create the graphical elements of the application and D3.js to create
 						 the interactive charts.</p>
					
					<p><span>Technologies used: </span>
					<a href="https://nodejs.org/en/" target="_blank" title="Node.js"><i className="fab fa-node technologies-used-icon icon-green"></i></a>
					<a href="https://angular.io/" target="_blank" title="Angular 4"><i className="fab fa-angular technologies-used-icon icon-red"></i></a>
					<a href="https://www.sqlite.org/" target="_blank" title="Sqlite"><i className="fas fa-database technologies-used-icon"></i></a>
			  			<a href="https://d3js.org/" target="_blank" title="D3.js">
			  			<i className="fas fa-chart-line technologies-used-icon"></i></a><br/>
			  			<span className="project-category"><i class="fas fa-tag"></i>: Web Application</span>
			  			</p>
			  			
			  			<p><a href="https://github.com/thanospappas/SchemaHistoryInvestigator" target="_blank" title="code">
			  			<i className="fas fa-code"></i> View Project on Github </a></p>
				</div>

				

				<div className="project">
					<div className="row">
						<div className="col-md-8">
							<div className="featured-title">
								Hecate 
							</div>
						</div>
						<div className="col-md-4">
							Feb 2017 - Jun 2017
						</div>
					</div>
					
					<div className="subheading">
						Diff visualization between 2 SQL schemas
					</div>
					<div className="project-content"> 
						 <p>Re-engineering of a legacy system using design patterns and refactoring techniques.</p>
						 <p><b>Technologies:</b> Java, Swing, Re-engineering, Design Patterns<br/>
						 	<span className="project-category"><i class="fas fa-tag"></i>: Desktop Application</span>
						 </p>
						 <p></p>
						 <p><a href="https://github.com/thanospappas/Hecate" target="_blank" title="code">
			  			<i className="fas fa-code"></i> View Project on Github </a></p>
					</div>
				</div>

				<div className="project">
					<div className="row">
						<div className="col-md-8">
							<div className="featured-title">
								MUSES 
							</div>
						</div>
						<div className="col-md-4">
							Oct 2014 - Sep 2015
						</div>
					</div>
					
					<div className="subheading">
							Miner of Useful Sequences in the Evolution of Schemata
						</div>
					<div className="project-content"> 
						 <p>Tool which receives as input all the changes that the schema of a database has 
						 undergone and produces as output frequent patterns from these changes.</p>
						 <p><b>Technologies:</b> Java, JavaFx, Data Mining, Sequence Mining<br/>
						 	<span className="project-category"><i class="fas fa-tag"></i>: Desktop Application</span>
						 </p>
						 <p></p>
						 <p><a href="https://github.com/DAINTINESS-Group/MUSES" target="_blank" title="code">
			  			<i className="fas fa-code"></i> View Project on Github </a></p>
					</div>
				</div>


				<div className="project">
					<div className="row">
						<div className="col-md-8">
							<div className="featured-title">
								Web Sites & Apps
							</div>
						</div>
						<div className="col-md-4">
							Oct 2013 - Current
						</div>
					</div>
					
					<div className="subheading">
							All these years I have worked on various web applications and websites.
					</div>
	
					<div className="project-content weblist"> 
						<div className="row ">
							<div className="col-md-6">
								<div className="web-project-row">
								<a href="https://www.vervendo.com" target="_blank" title="website">
									<img className="img-fluid" src={vervendo} />
									</a>
									<p><span>Vervendo.com:</span> <a href="https://www.vervendo.com/" target="_blank" title="website">
									Visit Website </a> </p>
								  	<p><span className="web-tech"><i class="fas fa-tag"></i> Angular 6, Java EE, ngrx</span></p>
								</div>
							</div>
							<div className="col-md-6">
							<div className="web-project-row">
							<a href="https://itunes.apple.com/us/app/auntie-lusinda/id1384838803?mt=8" target="_blank" title="website">
								<img className="img-fluid" src={auntielucinda} />
								</a>
								<p>Auntie Lucinda: <a href="https://itunes.apple.com/us/app/auntie-lusinda/id1384838803?mt=8" target="_blank" title="website">
			  					Visit Website </a></p>
								  <p><span className="web-tech"><i class="fas fa-tag"></i> Android, IOS, Mobile Application</span></p>
							</div>
							</div>
						</div>

						<div className="row ">
							<div className="col-md-6">
								<div className="web-project-row">
								<a href="https://www.pragmaworld.net/" target="_blank" title="website">
									<img className="img-fluid" src={pragmaworld} />
									</a>
									<p><span>Pragma:</span> <a href="https://www.pragmaworld.net/" target="_blank" title="website">
									Visit Website </a> </p>
								  	<p><span className="web-tech"><i class="fas fa-tag"></i> Wordpress</span></p>
								</div>
							</div>
							<div className="col-md-6">
							<div className="web-project-row">
							<a href="http://matchaoutlet.com/" target="_blank" title="website">
								<img className="img-fluid" src={mo} />
								</a>
								<p>Matchaoutlet: <a href="http://matchaoutlet.com/" target="_blank" title="website">
			  					Visit Website </a></p>
								  <p><span className="web-tech"><i class="fas fa-tag"></i> Shopify</span></p>
							</div>
							</div>
						</div>

						<div className="row ">
							<div className="col-md-6">
								<div className="web-project-row">
								<a href="https://www.mbawinner.com" target="_blank" title="website">
									<img className="img-fluid" src={mbawinner} />
									</a>
									<p>MBA Winner:  
						 <a href="https://www.mbawinner.com" target="_blank" title="website">
			  			 Visit Website </a></p>
							
							
								 <p> <span className="web-tech"><i class="fas fa-tag"></i> Wordpress
						 </span></p>
								</div>
							</div>
							<div className="col-md-6">
							<div className="web-project-row">
							<a href="https://www.roundaroundtire.com/eshop" target="_blank" title="website">
								<img className="img-fluid" src={roundaroundtire} />
								</a>
								<p>Round & Around Tire:  
						 <a href="https://www.roundaroundtire.com/eshop" target="_blank" title="website">Visit Website </a></p>
							
								 <p> <span className="web-tech"><i class="fas fa-tag"></i> Wordpress, Woocomerce
						 </span></p>
							</div>
							</div>
						</div>

						<div className="row ">
							<div className="col-md-6">
								<div className="web-project-row">
								<a href="https://www.funtales4kids.com" target="_blank" title="website">
									<img className="img-fluid" src={funtales4kids} />
									</a>
									<p><span>Fun Tales 4 Kids:</span> <a href="https://www.funtales4kids.com" target="_blank" title="website">
									Visit Website </a> </p>
								  	<p><span className="web-tech"><i class="fas fa-tag"></i> Wordpress</span></p>
								</div>
							</div>
							<div className="col-md-6">
							<div className="web-project-row">
							<a href="#" target="_blank" title="website">
								<img className="img-fluid" src={bodysculptor} />
								</a>
								<p>Bodysculptor: <a href="#" target="_blank" title="website">
			  					Visit Website </a></p>
								  <p><span className="web-tech"><i class="fas fa-tag"></i> Wordpress</span></p>
							</div>
							</div>
						</div>

						<div className="row ">
							<div className="col-md-6">
								<div className="web-project-row">
								<a href="http://grhost.eu/cs/" target="_blank" title="website">
									<img className="img-fluid" src={cseuoi} />
									</a>
									<p>Computer Science & Engineering <br/> University of Ioannina:  
						 <a href="http://grhost.eu/cs/" target="_blank" title="website">
			  			 View Project </a> </p>
							
								 <p><span className="web-tech"><i class="fas fa-tag"></i> Wordpress</span></p>
								</div>
							</div>
							<div className="col-md-6">
							<div className="web-project-row">
							<a href="http://http://datalab.cs.uoi.gr/" target="_blank" title="website">
								<img className="img-fluid" src={datalab} />
								</a>
								<p>DataLab: <a href="http://http://datalab.cs.uoi.gr/" target="_blank" title="website">
			  					Visit Website </a></p>
								  <p><span className="web-tech"><i class="fas fa-tag"></i> Wordpress</span></p>
							</div>
							</div>
						</div>

						<div className="row ">
							<div className="col-md-6">
								<div className="web-project-row">
								<a href="https://www.avakian.gr/" target="_blank" title="website">
									<img className="img-fluid" src={avakian} />
									</a>
									<p><span>Avakian:</span> <a href="https://www.avakian.gr/" target="_blank" title="website">
									Visit Website </a> </p>
								  	<p><span className="web-tech"><i class="fas fa-tag"></i> Wordpress, Woocommerce</span></p>
								</div>
							</div>
							<div className="col-md-6">
							<div className="web-project-row">
							<a href="http://crawfordjazzproject.org" target="_blank" title="website">
								<img className="img-fluid" src={crawford} />
								</a>
								<p>Crawford Jazz Project: <a href="http://crawfordjazzproject.org" target="_blank" title="website">
			  					Visit Website </a></p>
								  <p><span className="web-tech"><i class="fas fa-tag"></i> Wordpress</span></p>
							</div>
							</div>
						</div>


						<div className="row more-projects-section">
							<h2>Do you want to see more?</h2>
						</div>

						<div className="row web-project-row" >
							<div className="col-md-7">
								<p>Create your calendar</p>
							</div>
							<div className="col-md-5">
								 <p> <span className="web-tech"><i class="fas fa-tag"></i> Angular, PHP, Wordpress
						 		</span></p>
							</div>
							<div className="col-md-12">
							<p>Web Application where the user can select one of the 
								predifined calendar templates and place in each month the photo of his selection.</p>
								</div>

						</div>

						<div className="row web-project-row">
							<div className="col-md-7">
								<p>Solar Energy Calculator</p>
							</div>
							<div className="col-md-5">
								 <p> <span className="web-tech"><i class="fas fa-tag"></i> Angular, Node.js, MySQL</span></p>
							</div>
						</div>
						 	 
					</div>
				</div>

				<div className="project">
					<div className="row">
						<div className="col-md-8">
							<div className="featured-title">
								ESl 
							</div>
						</div>
						<div className="col-md-4">
							Dec 2015 - Feb 2016
						</div>
					</div>
					<div className="subheading">
							Extractor of positive and negative linked network
						</div>
					<div className="project-content"> 
						 <p>This tool extracts a signed network from 
					Reddit based on the pair-wise interactions of the users, and examine whether 
					or not the stability properties hold.</p>
						 <p><b>Technologies:</b> Python, Sklearn, Networkx, NLTK, Big Data<br/>
						 	<span className="project-category"><i class="fas fa-tag"></i>: Big Data, Data Mining</span>
						 </p>
						 <p></p>
						 <p><a href="https://github.com/thanospappas/ESl" target="_blank" title="code">
			  			<i className="fas fa-code"></i> View Project on Github </a></p>
					</div>
				</div>

				<div className="project">
					<div className="row">
						<div className="col-md-8">
							<div className="featured-title">
								Business Intelligence 
							</div>
						</div>
						<div className="col-md-4">
							Feb 2016 - Jun 2016
						</div>
					</div>
					
					<div className="subheading">
							Loading a Data warehouse Using ETL Tools & Time Series Analysis Using R
						</div>
					<div className="project-content"> 
						 <p>Data cleaning and ETL (Extract Tranform Load) to a relational database. Then we used R scripts
						 to retrieve the selected time series from the data warehouse and we conducted a time series analysis.</p>
						 <p><b>Technologies:</b> ETL, Pentaho, R, Big Data, MySQL<br/>
						 	<span className="project-category"><i class="fas fa-tag"></i>: Big Data, Time Series Analysis</span>
						 </p>
						 <p></p>
						 <p><a href="http://cs.uoi.gr/~apappas/projects/ETL&TimeSeriesAnalysis/" target="_blank" title="code">
			  			<i className="fas fa-code"></i> View Project </a></p>
					</div>
				</div>

				

			</div>
		);
	}


}
export default Projects;


// WEBPACK FOOTER //
// ./src/Projects.js